<template>
  <div>
    <Header />
    <div
      class="container mx-auto max-w-[1200px] w-full py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div class="flex justify-end px-6">
        <router-link
          :to="{ name: 'InstructorHome' }"
          class="bg-blues text-white rounded-lg text-sm font-semibold px-5 py-1"
          >Back</router-link
        >
      </div>
      <div class="flex justify-center">No Data Found</div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
  },
  computed: mapGetters(["userInfo"]),
};
</script>

<style></style>
